
import { defineComponent, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: {},
  setup() {
    const state = reactive({})
    const route = useRoute()
    const linkClass = (link: string) => (route.path === link ? 'active' : '')

    return reactive({
      ...toRefs(state),
      linkClass,
    })
  },
})
